import { apiCallCenterOperador } from '@/plugins/axios'

export default {
  verificaLogin(codigoOperador) {
    return apiCallCenterOperador().get(`/agent/login/status/${codigoOperador}`)
  },
}
